<template>
   <div class="asq-follow-up-wrapper" style="display: flex;">
    <div ref="notePopup">
        <div class="notepop-overlay"></div>
        <div class="notePop">
            <textarea class="notePopupTextarea" placeholder="Type here" @input="evt => updateNote(evt)" :value="note"></textarea>
            <div class="buttons-wrapper">
              <button class="button cancel" @click="showClearNoteAlert()">Cancel</button>
              <button class="button save" @click="hideNotePopup()">Save</button>
            </div>
        </div>
    </div>
    <div class="alert-popup" v-show="clearNoteAlertShow">
        <div class="alert-overlay">
          <div class="alert-wrapper">
            <div class="title">Do you want to remove the note?</div>
            <div class="buttons-wrapper" style="position: relative; right: unset; bottom: unset; margin-top: 30px;">
              <button class="button no" @click="handleNotRemoveNote()">No</button>
              <button class="button yes" @click="handleRemoveNote()" >Yes</button>
            </div>
          </div>
        </div>
    </div>
    <div class="note-container">
        <div class="note-header">
            <span>Notes</span>
            <div class="dashboard-icon">
                <img class="coloured-icon" src="../../../assets/images/note-yellow.svg" /> 
            </div>
        </div>
        <div class="note-contents">
            <div v-if="note==''" class="add-note" @click="showNotePopup()">
                <span >add note</span>
                <div class="dashboard-icon">
                    <img class="coloured-icon" src="../../../assets/images/note-yellow.svg" /> 
                </div>
            </div>
            <div v-if="note != ''" class="edit-note" @click="showNotePopup()">
              <div class="dashboard-icon">
                  <img class="coloured-icon" src="../../../assets/images/note-yellow.svg" /> 
              </div>
              <div style="margin-left: 5px;margin-right: 10px;">Note added</div>
              <div class="edit-pencil-btn">
                  <div style="color: rgb(0, 156, 124); font-size: 13px; margin-right: 5px;">edit</div>
                  <img class="coloured-icon" src="../../../assets/images/edit-pencil.svg" /> 
              </div>
            </div>
        </div>
    </div>
    <div class="followup-container">
        <div class="followup-header">
            <span>Follow-up action</span>
            <div class="dashboard-icon">
                <img class="coloured-icon" src="../../../assets/images/follow-up-action-purple.svg" /> 
            </div>
        </div>
        <div class="follow-up-contents">
            <!-- <h1>Follow-up action required</h1> -->
            <div class="questions-wrapper">

                <div class="radio">
                    <input id="no_further_actions" name="no_further_actions" type="radio" @click="evt => updateFurtherActions('no_further_actions','selected',!no_further_actions)" :checked="no_further_actions ? 'checked' : ''">
                    <label  for="no_further_actions" class="radio-label">{{ question.question.no_further_actions }}</label>
                </div>

                <div class="radio">
                    <input id="provide_activities" name="provide_activities" type="radio" @click="evt => updateProvideActivities('provide_activities','selected',!provide_activities)" :checked="provide_activities ? 'checked' : ''">
                    <label  for="provide_activities" class="radio-label">{{ question.question.provide_activities.split('#')[0] }}</label>
                    <input type="text" :value="updatedAnswer['provide_activities'] && updatedAnswer['provide_activities'].month > 0 ? updatedAnswer['provide_activities'].month : ''" placeholder="#" @input="evt => updateProvideActivities('provide_activities','month',evt.target.value)">
                    <label  for="provide_activities" class="radio-label">{{ question.question.provide_activities.split('#')[1] }}</label>
                </div>

                <div class="radio">
                    <input id="share_results" name="share_results" type="radio" @click="evt => updateShareResults('share_results','selected',!share_results)" :checked="share_results ? 'checked' : ''">
                    <label  for="share_results" class="radio-label">{{ question.question.share_results }}</label>
                </div>
                
                <ReferralsDropdownPanel :add_referrals="add_referrals" @input="toggleReferral" @updateReferrals="updateReferrals"/>
                
            </div>
        </div>
    </div>

    <div class="referral-container">
        <div class="referral-header">
            <span>Referral</span>
            <div class="dashboard-icon">
                <img class="coloured-icon" src="../../../assets/images/create-referral-purple.svg" /> 
            </div>
        </div>
        <div class="referral-contents">
            <div class="create-referral" @click="add_referrals=!add_referrals">
                <span v-if="referrals.length > 0" style="margin-left: 25px;margin-right: 20px;">new referral</span>
                <span v-else>create referral</span>
                <!-- <span>add referral</span> -->
                <div class="dashboard-icon">
                    <img class="coloured-icon" src="../../../assets/images/create-referral-purple.svg" /> 
                </div>
            </div>
            
        </div>
    </div>
   </div>
</template>
<script>
import ReferralsDropdownPanel from '@/components/ReferralsDropdownPanel';
export default {
  name: 'Asq3FollowUp',
  components: {
    ReferralsDropdownPanel,
  },
  data() {
    return {
        no_further_actions: false,
        provide_activities: false,
        month: "",
        share_results: false,
        updatedAnswer: {},
        add_referrals: false,
        note: '',
        referrals:[],
        clearNoteAlertShow: false,
    };
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: [Object,String],
      required: false,
    },
  },
  watch: {
    answer(newAnswer, oldAnswer) {
      if(typeof newAnswer === 'string')
      {
        this.updatedAnswer = JSON.parse(newAnswer);
        this.updatedAnswer['notes'] = '';
      }
    }
  },
  methods: {
    updateFurtherActions(title, subtitle, value) {
        this.no_further_actions = value;
        this.provide_activities = false;
        this.month = "";
        this.share_results = false;
        //this.add_referrals = false;
        this.updateAnswers();
    },
    updateProvideActivities(title, subtitle, value){
        this.no_further_actions = false;
        if(subtitle == 'selected'){
            this.provide_activities = value;
            if(value == false)
            this.month="";
        }
        else if(subtitle == 'month')
            this.month = value;
        this.updateAnswers();
    },
    updateShareResults(title, subtitle, value){
        this.no_further_actions = false;
        this.share_results = value;
        this.updateAnswers();
    },
    updateNote(evt){
        this.note = evt.target.value;
        
        if(!this.updatedAnswer['notes']) {
            this.updatedAnswer['notes'] = '';
            this.updatedAnswer['notes'] = this.note;
        } else {
            this.updatedAnswer['notes'] = this.note;
        }
        this.updateAnswers();
    },
    updateReferrals(data){
        this.referrals.push(...data);
        if(!this.updatedAnswer['referrals']) {
            this.updatedAnswer['referrals'] = [];
            this.updatedAnswer['referrals'] = data;
        } else {
            // this.updatedAnswer['referrals'] = data;
            this.updatedAnswer['referrals'].push(...data);
        }
        this.updateAnswers();
    },
    updateAnswers() {
        //no_further_actions
        if(!this.updatedAnswer['no_further_actions']) {
            this.updatedAnswer['no_further_actions'] = {};
            this.updatedAnswer['no_further_actions'].selected = this.no_further_actions;
        } else {
            this.updatedAnswer['no_further_actions'].selected = this.no_further_actions;
        }
        //provide_activities
        if(!this.updatedAnswer['provide_activities']) {
            this.updatedAnswer['provide_activities'] = {};
            this.updatedAnswer['provide_activities'].selected = this.provide_activities
            this.updatedAnswer['provide_activities'].month = this.month;
        } else {
            this.updatedAnswer['provide_activities'].selected = this.provide_activities;
            this.updatedAnswer['provide_activities'].month = this.month;
        }
        //share_results
        if(!this.updatedAnswer['share_results']) {
            this.updatedAnswer['share_results'] = {};
            this.updatedAnswer['share_results'].selected = this.share_results;
        } else {
            this.updatedAnswer['share_results'].selected = this.share_results;
        }
        if(this.updatedAnswer['share_results'].selected == true || this.updatedAnswer['no_further_actions'].selected == true || this.updatedAnswer['provide_activities'].selected == true){
            if(this.updatedAnswer['provide_activities'].selected == true)
            {
                if(this.updatedAnswer['provide_activities'].month == "")
                this.$emit('input', null);
                else
                this.$emit('input', this.updatedAnswer);
            }
            else
            this.$emit('input', this.updatedAnswer);
            //console.log('updatedAnswer:'+JSON.stringify(this.updatedAnswer));
        }
        else{
            this.$emit('input', null);
        }
        
    },
    toggleReferral(value){
        this.add_referrals = value;
    },
    showNotePopup() {
        $(this.$refs.notePopup).show(500);
    },
    async hideNotePopup() {
        $(this.$refs.notePopup).hide(500);
        let response = await this.$http.put('/survey/updateNotes', {
            notes: this.note,
            compulsoryPoint: localStorage.getItem('compulsoryPoint')
        });
    },
    showClearNoteAlert() {
      this.clearNoteAlertShow = true;
    },
    handleNotRemoveNote() {
      this.clearNoteAlertShow = false;
    },
    handleRemoveNote() {
      this.note = '';
      this.updatedAnswer['notes'] = undefined;
      $(this.$refs.notePopup).hide(500);
      this.clearNoteAlertShow = false;
    }
  },
  mounted() {
    $(this.$refs.notePopup).css("display", "none");
    if(typeof this.answer === 'string') {
      this.updatedAnswer = JSON.parse(this.answer);
    //   if(this.updatedAnswer['referrals']) {
    //     this.updatedAnswer['referrals'] = [];
    //   }
      //console.log('updatedAnswer:'+JSON.stringify(this.updatedAnswer));
      this.updatedAnswer['referrals'] = [];
      this.referrals = [];
      this.no_further_actions = this.updatedAnswer['no_further_actions'].selected;
      this.provide_activities = this.updatedAnswer['provide_activities'].selected;
      this.share_results = this.updatedAnswer['share_results'].selected;
      this.month = this.updatedAnswer['provide_activities'].month;
      this.updatedAnswer['notes'] = '';
      this.updatedAnswer['compulsory_point'] = '';
      // this.note = this.updatedAnswer['notes'] ? this.updatedAnswer['notes'] : this.note;
      this.updateAnswers();
    }
    const compulsoryPoint = localStorage.getItem('compulsoryPoint');
    if(compulsoryPoint && compulsoryPoint != '') {
      if(!this.updatedAnswer['compulsory_point']) {
          this.updatedAnswer['compulsory_point'] = '';
          this.updatedAnswer['compulsory_point'] = compulsoryPoint;
      } else {
          this.updatedAnswer['compulsory_point'] = compulsoryPoint;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
$color1: #f4f4f4;
$color2: #912b86;
.follow-up-contents{
    padding: 10px;
    border-radius: 27px 0 45px;
    z-index: 1000;
    box-shadow: 0 3px 6px #00000029;
    cursor: pointer;
    height: 55px;
    min-height: 250px;
    background-color: #f9f3f8;
    margin-top: 10px;
    .questions-wrapper{
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        .radio {
            margin: 0.5rem;
            width: 420px;
            padding: 5px 20px 0px 20px;
            border-radius: 25px;
            display: flex;
            flex-direction: row;
            input[type="text"]{
                border: none !important;
                height: 25px;
                border-radius: 12px;
                text-align: center;
                width: 40px;
                background: #ffffff;
                outline: none;
                margin: 0px 4px;
            }
            input[type="radio"] {
                position: absolute;
                opacity: 0;
                + .radio-label {
                &:before {
                    content: '';
                    background: #ffffff;
                    border-radius: 100%;
                    border: 1px solid darken($color1, 25%);
                    display: inline-block;
                    width: 1.4em;
                    height: 1.4em;
                    position: relative;
                    top: -0.2em;
                    margin-right: 1em; 
                    vertical-align: top;
                    cursor: pointer;
                    text-align: center;
                    transition: all 250ms ease;
                    border: 2px solid $color2;
                    z-index: 0;
                    
                }
                }
                &:checked {
                    + .radio-label {
                        &:before {
                        background-color: $color2;
                        box-shadow: inset 0 0 0 4px $color1;
                        }
                    }
                }
                &:focus {
                    + .radio-label {
                        &:before {
                        outline: none;
                        border-color: $color2;
                        }
                    }
                }
                &:disabled {
                    + .radio-label {
                        &:before {
                        box-shadow: inset 0 0 0 4px $color1;
                        border-color: darken($color1, 25%);
                        background: darken($color1, 25%);
                        }
                    }
                }
                + .radio-label {
                    &:empty {
                        &:before {
                        margin-right: 0;
                        }
                    }
                }
            }
        }
    }
}

.asq-follow-up-wrapper{
    .note-container{
        .note-header{
            padding: 10px;
            border-radius: 27px 0 45px;
            z-index: 1000;
            box-shadow: 0 3px 6px #00000029;
            width: 225px;
            cursor: pointer;
            height: 55px;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: #f3ac1a;
            span{
                margin-left: 65px;
                margin-right: 44px;
                color: #fff
            }
            .dashboard-icon{
                background-color: #fff;
                border-radius: 50px;
                width: 45px;
                height: 45px;
                display: flex;
                justify-content: center;
                align-items: stretch;
                flex-wrap: wrap;
            }
        }
        .note-contents{
            padding: 10px;
            border-radius: 27px 0 45px;
            z-index: 1000;
            box-shadow: 0 3px 6px #00000029;
            width: 225px;
            cursor: pointer;
            height: 55px;
            display: flex;
            flex-direction: row;
            align-items: center;
            min-height: 250px;
            background-color: #fef8ec;
            margin-top: 10px;
            justify-content: center;
            //position: relative;
            // &:after{
            //     content: '';
            //     width: 20px;
            //     height: 16px;
            //     top: auto;
            //     right: 0;
            //     bottom: 100%;
            //     left: auto;
            //     position: absolute;
            //     background-color: #fef8ec;
            // }
            // &:before{
            //     content: '';
            //     width: 32px;
            //     height: 25px;
            //     top: -25px;
            //     right: 0px;
            //     bottom: auto;
            //     left: auto;
            //     position: absolute;
            //     background-color: #ffffff;
            //     z-index: 1;
            //     border-bottom-right-radius: 60%;
            // }
            .add-note{
                width: 122px;
                height: 30px;
                background-color: #f3ac1a;
                color: #ffffff;
                border-radius: 15px;
                display: flex;
                flex-direction: row;
                align-items: center;
                span{
                    margin-left: 22px;
                    margin-right: 11px;
                    color: #fff;
                }
                .dashboard-icon{
                    background-color: #fff;
                    border-radius: 50px;
                    width: 25px;
                    height: 25px;
                    display: flex;
                    justify-content: center;
                    align-items: stretch;
                    flex-wrap: wrap;
                    img{
                        width: 14px;
                        height: 24px;
                    }
                }
            }
            .edit-note {
              display: flex;
              align-items: center;
              .edit-pencil-btn {
                display: flex;
                align-items: center;
              }
            }
        }
    }
    .followup-container{
        margin-left: 20px;
        .followup-header{
            padding: 10px;
            border-radius: 27px 0 45px;
            z-index: 1000;
            box-shadow: 0 3px 6px #00000029;
            cursor: pointer;
            height: 55px;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: #912b86;
            span{
                margin-left: 120px;
                margin-right: 143px;
                color: #fff
            }
            .dashboard-icon{
                background-color: #fff;
                border-radius: 50px;
                width: 45px;
                height: 45px;
                display: flex;
                justify-content: center;
                align-items: stretch;
                flex-wrap: wrap;
            }
        }
    }

    .referral-container{
        margin-left: 20px;
        .referral-header{
            padding: 10px;
            border-radius: 27px 0 45px;
            z-index: 1000;
            box-shadow: 0 3px 6px #00000029;
            width: 300px;
            cursor: pointer;
            height: 55px;
            display: flex;
            flex-direction: row;
            align-items: center;
            background-color: #6f539e;
            span{
                margin-left: 97px;
                margin-right: 74px;
                color: #fff
            }
            .dashboard-icon{
                background-color: #fff;
                border-radius: 50px;
                width: 45px;
                height: 45px;
                display: flex;
                justify-content: center;
                align-items: stretch;
                flex-wrap: wrap;
            }
        }
        .referral-contents{
            padding: 10px;
            border-radius: 27px 0 45px;
            z-index: 1000;
            box-shadow: 0 3px 6px #00000029;
            width: 300px;
            cursor: pointer;
            height: 55px;
            display: flex;
            flex-direction: row;
            align-items: center;
            min-height: 250px;
            background-color: #f4f2f7;
            margin-top: 10px;
            justify-content: center;
            .create-referral{
                width: 154px;
                height: 30px;
                background-color: #6f539e;
                color: #ffffff;
                border-radius: 15px;
                display: flex;
                flex-direction: row;
                align-items: center;
                span{
                    margin-left: 22px;
                    margin-right: 11px;
                    color: #fff;
                }
                .dashboard-icon{
                    background-color: #fff;
                    border-radius: 50px;
                    width: 25px;
                    height: 25px;
                    display: flex;
                    justify-content: center;
                    align-items: stretch;
                    flex-wrap: wrap;
                    img{
                        width: 14px;
                        height: 24px;
                    }
                }
            }
        }
    }
}


.notePop {
    position: absolute;
    top: 44%;
    color: black;
    border-radius: 15px;
    width: 704px;
    height: 270px;
    box-shadow: 7px 7px 15px #00000029;
    background-color: transparent;
    left: 34%;
    transform: translate(-50%, -50%);
    z-index: 1;
    .close{
        width: 21px !important;
        position: absolute;
        right: 17px !important;
        top: 13px;
        padding: 5px !important;
        cursor: pointer !important;
        left: unset !important;
    } 
    .notePopupTextarea{
        border: none;
        border-color: #d9d9d9;
        overflow: hidden;
        border-radius: 25px;
        padding: 35px 40px 50px 15px;
        margin-left: 29px;
        margin-top: 66px;
        width: 100%;
        box-shadow: 5px 3px 15px #00000029;
        font-family: inherit;
        font-size: 12px;
        height: 100%;
        margin: 0;
        //font: inherit;
        color: inherit;
        border-radius: 15px;
        background-color: #fef8ec;
        resize: none;
        overflow: auto;
        &:focus{
            outline: none;
        }
        // &::-webkit-scrollbar {
        //     width: 10px;
        // }

        // &::-webkit-scrollbar-track {
        //     background-color: #ffffff;
        //     //border-radius: 6px;
        // }

        // &::-webkit-scrollbar-thumb {
        //     background-color: #f3ac1a;
        //     //border-radius: 6px;
        // }
        // &::-webkit-scrollbar-track:hover {
        //     cursor: pointer;
        // }
    }

}

.notepop-overlay{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: calc(100% + 79px);
  background-color: rgba(255,255,255,0.8);
  z-index: 1;
}

.alert-overlay {
  position: absolute;
  left: -10px;
  top: -3px;
  width: calc(100% + 10px);
  height: calc(100% + 82px);
  background-color: rgba(255,255,255,1);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-wrapper {
  width: 400px;
  height: 200px;
  margin-top: -200px;
  background-color: #E4F4F9;
  border-radius: 50px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title {
    font-size: 18px;
  }
}

.buttons-wrapper {
  position: absolute;
  right: 17px;
  bottom: 13px;
  .button {
    background: #FFFFFF;
    border: none;
    border-radius: 15px;
    height: 35px;
    font-size: 14px;
    font-weight: 500;
    font-family: 'MyriadPro';
    box-shadow: 0px 2px 7px -1px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    padding: 7px 22px 6px 22px;
  }
  .cancel {
    color: #A2A4A7;
    margin-right: -15px;
  }
  .save {
    color: #f3ac1a;
  }
  .cancel:active {
    position: relative;
    background: #f3ac1a;
    color: #FFFFFF;
    z-index: 1;
  }
  .save:active {
    position: relative;
    background: #f3ac1a;
    color: #FFFFFF;
    z-index: 1;
  }
  .no {
    color: #A2A4A7;
    margin-right: 15px;
  }
  .yes {
    color: #3487A3;
  }
  .no:active {
    position: relative;
    background: #3487A3;
    color: #FFFFFF;
    z-index: 1;
  }
  .yes:active {
    position: relative;
    background: #3487A3;
    color: #FFFFFF;
    z-index: 1;
  }
}
</style>